import React from 'react';
import {
  Alert,
  Box,
  CircularProgress
} from '@mui/material';
import {
  Navigate,
  useLocation
} from 'react-router-dom';
import { useAuth } from './AuthContext.tsx';

export function ProtectedRoute({
  children,
  requiredRole
}: {
  children: React.ReactElement;
  requiredRole:
    | 'admin'
    | 'customer';
}) {
  const {
    loading,
    configured,
    user,
    role
  } = useAuth();

  const loc = useLocation();

  if (!configured) {
    return (
      <Box sx={{ p: 4 }}>
        <Alert severity="warning">
          Supabase is nog niet
          gekoppeld aan deze build.
        </Alert>
      </Box>
    );
  }

  if (loading) {
    return (
      <Box
        sx={{
          p: 6,
          textAlign: 'center'
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    return (
      <Navigate
        to="/inloggen"
        replace
        state={{
          from: loc.pathname
        }}
      />
    );
  }

  // Nooit naar dezelfde beveiligde
  // route terugsturen wanneer de rol
  // ontbreekt; dat veroorzaakte het
  // lege Mijn Pippaya-scherm.
  if (!role) {
    return (
      <Box sx={{ p: 4 }}>
        <Alert severity="error">
          Je account is ingelogd,
          maar de Mijn Pippaya-rol
          kon niet worden geladen.
          Log uit en opnieuw in. Blijft
          dit staan, neem dan contact
          op met Pippaya.
        </Alert>
      </Box>
    );
  }

  if (role !== requiredRole) {
    return (
      <Navigate
        to={
          role === 'admin'
            ? '/beheer'
            : '/mijn-pippaya'
        }
        replace
      />
    );
  }

  return children;
}
